import { render, staticRenderFns } from "./TeamCommunityModal.vue?vue&type=template&id=28abe197&scoped=true"
import script from "./TeamCommunityModal.vue?vue&type=script&lang=js"
export * from "./TeamCommunityModal.vue?vue&type=script&lang=js"
import style0 from "./TeamCommunityModal.vue?vue&type=style&index=0&id=28abe197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28abe197",
  null
  
)

export default component.exports